import * as deviceActions from '@Actions/device';
import { getDeviceStatus } from '@Actions';
import { error, success } from '@innovyze/stylovyze';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	createResampleJob,
	resample as resampleSensorService,
	ResampleRequestBody,
	ResampleRequestBodyDates,
	ResampleResponsePayload,
} from '@Services/device';
import { AxiosResponse } from 'axios';
import { delay, put, retry, takeLatest } from 'redux-saga/effects';
import { ResampleJobRequest, ResampleJobResponse } from '@Types/sensorResample';

function* resampleSensorsSaga(action: PayloadAction<ResampleRequestBody>) {
	const { resampleSensorResolved, resampleSensorRejected } = deviceActions;
	try {
		const response: AxiosResponse<ResampleResponsePayload> = yield retry(
			5,
			1500,
			resampleSensorService,
			action.payload,
		);
		if (response.data) {
			yield put(resampleSensorResolved(response.data));
			yield put(getDeviceStatus(action.payload.sensorId));
		} else {
			throw new Error('OperationStatus != SUCCESS');
		}
	} catch (ex) {
		const e = ex as Error;
		console.error(e);
		yield put(error(`Resample failure - ${e.message}`));
		yield put(resampleSensorRejected());
	}
}

function* resampleSensorsJobSaga(action: PayloadAction<ResampleJobRequest>) {
	try {
		const resampleJobResponse: AxiosResponse<ResampleJobResponse> =
			yield retry(1, 1500, createResampleJob, action.payload);
		if (resampleJobResponse?.data?.jobId) {
			yield put(delay(3000));
			yield put(deviceActions.resampleSensorJobResolved());
			yield put(success('Resample process started'));
		}
	} catch (ex) {
		const e = ex as Error;
		console.error(e);
		yield put(delay(3000));
		yield put(error(`Resample failure - ${e.message}`));
		yield put(deviceActions.resampleSensorJobRejected());
	}
}

function* resampleAllSensorsSaga(
	action: PayloadAction<ResampleRequestBodyDates>,
) {
	const { resampleAllSensorsResolved, resampleAllSensorsRejected } =
		deviceActions;
	try {
		const requestParams: ResampleRequestBody = {
			...action.payload,
			sensorId: '*',
		};
		const response: AxiosResponse<ResampleResponsePayload> = yield retry(
			5,
			1500,
			resampleSensorService,
			requestParams,
		);
		if (response.data) {
			yield put(resampleAllSensorsResolved(response.data));
		} else {
			throw new Error('OperationStatus != SUCCESS');
		}
	} catch (ex) {
		const e = ex as Error;
		console.error(e);
		yield put(error(`Resample All failure - ${e.message}`));
		yield put(resampleAllSensorsRejected());
	}
}

function* watchResampleSensor() {
	yield takeLatest(deviceActions.resampleSensor, resampleSensorsSaga);
}
function* watchResampleJobSensor() {
	yield takeLatest(deviceActions.resampleSensorJob, resampleSensorsJobSaga);
}
function* watchResampleAllSensors() {
	yield takeLatest(deviceActions.resampleAllSensors, resampleAllSensorsSaga);
}

export default [
	watchResampleSensor(),
	watchResampleAllSensors(),
	watchResampleJobSensor(),
];
